import { SettingsRemote as ToyIcon, Vibration as VibrationIcon } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Stack, Tooltip, Typography } from '@mui/material';
import { LovenseToyItem } from '../../../../hooks/useLovense';

interface ToyDetailsProps {
    toy: LovenseToyItem;
    onTestCommand: () => void;
    isTestCommandRunning: boolean;
}

const ToyDetails = (props: ToyDetailsProps) => {
    const { toy, onTestCommand, isTestCommandRunning } = props;

    return (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent={'space-between'} mb={2}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Tooltip title={toy.toyId ? `Toy ID: ${toy.toyId}` : 'Toy Disconnected'}>
                    <ToyIcon fontSize="small" color={toy.status === 1 ? 'success' : 'disabled'} />
                </Tooltip>
                <Typography
                    variant="h6"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {toy.nickName || toy.name}
                    {toy.nickName && toy.name ? ` (${toy.name})` : ''}
                </Typography>
            </Stack>
            <Tooltip title="Send Test Command">
                <LoadingButton
                    loading={isTestCommandRunning}
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                        onTestCommand();
                    }}
                    sx={{ minWidth: '40px' }}
                >
                    <VibrationIcon />
                </LoadingButton>
            </Tooltip>
        </Stack>
    );
};

export default ToyDetails;
